import { v4 as uuidv4 } from 'uuid';
import { getLocalStorage, setLocalStorage } from './general';
import { tributePerformanceModeEnum } from '../constants';

export function getTributeUploadSessionId() {
    const key = 'mst_upload_sessionId';
    const sessionId = getLocalStorage(key);

    if (sessionId) {
        return sessionId;
    } else {
        return null;
    }
}

export function setTributeUploadSessionId(sessionId) {
    const key = 'mst_upload_sessionId';

    setLocalStorage(key, sessionId);
    return sessionId;
}

export function getTributePerformanceMode() {
    const key = 'mst_performance_mode';
    const mode = getLocalStorage(key);

    const defaultValue = tributePerformanceModeEnum.FEATURES;

    const validValues = Object.values(tributePerformanceModeEnum);

    if (validValues.includes(mode)) {
        return mode;
    } else {
        return defaultValue;
    }
}

export function setTributePerformanceMode(val) {
    const key = 'mst_performance_mode';

    setLocalStorage(key, val);
    return val;
}
